/* tslint:disable */

declare var Object: any;
export interface ERPpurchaseRequestInterface {
  "id"?: number;
}

export class ERPpurchaseRequest implements ERPpurchaseRequestInterface {
  "id": number;
  constructor(data?: ERPpurchaseRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchaseRequest`.
   */
  public static getModelName() {
    return "ERPpurchaseRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchaseRequest for dynamic purposes.
  **/
  public static factory(data: ERPpurchaseRequestInterface): ERPpurchaseRequest{
    return new ERPpurchaseRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchaseRequest',
      plural: 'ERPpurchaseRequests',
      path: 'ERPpurchaseRequests',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchaseRequest.ts